
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investments/ecommerce",
      function () {
        return require("private-next-pages/investments/ecommerce.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investments/ecommerce"])
      });
    }
  